// icons/providers/custom.tsx
import * as React from 'react';
import type { IconToken } from '../types';

// Ejemplo: usar un componente SVG propio ya existente
// (el proyecto tiene assets/icons/WhatsappIcon.tsx)
import { WhatsappIcon } from '../custom-icons/WhatsappIcon';

type CustomMap = Partial<Record<IconToken, React.ComponentType<React.SVGProps<SVGSVGElement>>>>;

export const CUSTOM_MAP: CustomMap = {
  whatsapp: WhatsappIcon,
  // añade aquí más SVGs propios si los necesitas
};
